import { Button } from '@mantine/core';
import React, { useState } from 'react';
import { useWorkflowComposition } from '../hooks/useWorkflowComposition';

interface WorkflowCompositionManagerProps {
  tenant: string;
  name: string;
  version?: string;
  readOnly?: boolean;
}

// Life-critical UI: minimal, explicit actions; confirmations handled upstream
export const WorkflowCompositionManager: React.FC<WorkflowCompositionManagerProps> = ({ tenant, name, version, readOnly }) => {
  const { components, edges, loading, error, addComponent, connectComponents, removeComponent, validate, refetch } = useWorkflowComposition({ tenant, name, version });
  const [busy, setBusy] = useState(false);

  if (loading) return <div>Loading composition…</div>;
  if (error) return <div role="alert">Error loading composition</div>;

  return (
    <div>
      <div style={{ display: 'flex', gap: 16, alignItems: 'center', marginBottom: 12 }}>
        <strong>Composition</strong>
        <Button size="xs" variant="light" onClick={() => refetch()} disabled={busy}>Refresh</Button>
        <Button size="xs" variant="outline" onClick={async () => { setBusy(true); try { await validate(); } finally { setBusy(false); } }} disabled={busy}>Validate</Button>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
        <div>
          <h4>Components</h4>
          <ul>
            {components.map((c: any) => (
              <li key={c.id}>
                <code>{c.component_type}</code> {c.name} @{c.version_pin}
                {!readOnly && (
                  <Button size="xs" variant="subtle" onClick={async () => { setBusy(true); try { await removeComponent(c.id); } finally { setBusy(false); } }}>Remove</Button>
                )}
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4>Edges</h4>
          <ul>
            {edges.map((e: any) => (
              <li key={e.id}>
                {e.parent_component_id} → {e.child_component_id} {e.relationship ? `(${e.relationship})` : ''}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default WorkflowCompositionManager;


